export default "__VITE_ASSET__Dqwxlg2c__"